import { atom, PrimitiveAtom, Getter } from "jotai"
import { useAtomValue, useUpdateAtom } from "jotai/utils"

import type { Records, Column } from "./types"

const dataAtom = atom<Records<unknown>>({})
const dataKeysAtom = atom<string[]>((get) => {
  const records = get(dataAtom)
  return Object.keys(records)
})

type Action = {
  type: "remove_record"
  pld: { rowId: string }
}

export const actionsAtom = atom<null, Action>(null, (get, set, action) => {
  switch (action.type) {
    case "remove_record": {
      const data = { ...get(dataAtom) }
      delete data[action.pld.rowId]
      set(dataAtom, data)
    }
  }
})

export function getDataAtom<R>() {
  return dataAtom as PrimitiveAtom<Records<R>>
}

export function getRowById<R>(get: Getter, rowId: string) {
  return get(getDataAtom<R>())[rowId]
}

export function useDataKeys() {
  return useAtomValue(dataKeysAtom)
}

export function useUpdateData<R>() {
  return useUpdateAtom(getDataAtom<R>())
}

// columns
const columnsAtom = atom<Column[]>([])
const columnsKeysAtom = atom<string[]>((get) => {
  return get(columnsAtom).map((x) => x.id)
})

export function useColumnKeys() {
  return useAtomValue(columnsKeysAtom)
}

export function useColumn(columnId: string): Column | undefined {
  const columns = useAtomValue(columnsAtom)
  return columns.find((x) => x.id === columnId)
}

export function useUpdateColumns() {
  return useUpdateAtom(columnsAtom)
}
